export { default as FlightDetails } from "./FlightDetails";
